import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { FlexboxGrid } from 'rsuite'

import DocumentRequestButton from '../../Buttons/DocumentRequestButton'
import { Product } from '../../../utils/types/Product'
import PageIcon from '../../Icons/PageIcon'
import { AnalyticsSubLocation, DocumentType } from '../../../utils/types/analytics'
import useDocumentRequestModal from '../../Modals/hooks/useDocumentRequestModal'
import useGlobalAnalyticsParams from '../../hooks/useGlobalAnalyticsParams'

import styles from '../../../styles/ProductAttributes.module.less'

interface ProductDocumentsListProps {
  product: Product
}

const requestedDocumentData: { eventKey: DocumentType, value: string }[] = [
  {
    eventKey: 'product_data_sheet',
    value: 'Product datasheet',
  },
  {
    eventKey: 'product_standard_certificate',
    value: 'Product standard certificate',
  },
  {
    eventKey: 'declaration_of_conformity',
    value: 'EU Declaration of conformity',
  },
]

const ProductDocumentsList: FC<ProductDocumentsListProps> = ({ product }) => {
  const { t } = useTranslation('products')
  const [globalAnalyticsParams, setGlobalAnalyticsParams] = useGlobalAnalyticsParams()

  const { SingleProductStandards } = AnalyticsSubLocation
  const openDocumentRequestModal = useDocumentRequestModal({
    analyticsLocation: SingleProductStandards,
    product,
  })

  const handleClick = () => {
    setGlobalAnalyticsParams({
      ...globalAnalyticsParams,
      selectedDocument: { eventKey: 'other', value: 'Other' },
    })
    openDocumentRequestModal()
  }

  return (
    <>
      {requestedDocumentData.map((document) => (
        <DocumentRequestButton
          key={document.eventKey}
          product={product}
          Icon={PageIcon}
          text={document.value}
          selectedDocument={document}
        />
      ))}
      <p className="margin-top-spacer-double">
        {`${t('Anything missing')}?`}
        <FlexboxGrid
          className={styles['other-documents-text']}
          onClick={handleClick}
        >
          <b>{` ${t('Request other documents')}`}</b>
        </FlexboxGrid>
      </p>
    </>
  )
}
export default ProductDocumentsList
